export default function adaptEmployeeFromDetailModal({
  employee,
  benefitPlanId,
  taxRegime,
}) {
  return { ...employee, modelId: benefitPlanId, taxRegime };
}
